import { render, staticRenderFns } from "./RegisterTablet.vue?vue&type=template&id=ece5f05a&scoped=true"
import script from "./RegisterTablet.vue?vue&type=script&lang=js"
export * from "./RegisterTablet.vue?vue&type=script&lang=js"
import style0 from "./RegisterTablet.vue?vue&type=style&index=0&id=ece5f05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece5f05a",
  null
  
)

export default component.exports